<script setup lang="ts">
const { t } = useI18n()

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    de: '/datenschutz',
    en: '/privacy',
    hu: '/adatvédelem',
    tr: '/gizlilik',
    uk: '/конфіденційність',
  },
})

useSeoMeta({
  title: t('Introfy® - Datenschutz'),
})
</script>

<template>
  <LandingMainFrame>
    <p class="text-3xl font-bold">
      {{ t("Datenschutzhinweise") }}
    </p>
    <p class="text-xl font-bold mt-8">
      1. {{ t("Allgemeine Hinweise") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.1. {{ t("Datenschutzrechtlich Verantwortlicher") }}
    </p>
    <p class="mt-2">
      {{ t("Verantwortlicher ist die Introfy GmbH, Essener Str. 88c, 22419 Hamburg, Deutschland, info{'@'}introfy.app.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.2. {{ t("Rechtsgrundlagen der Verarbeitung personenbezogener Daten") }}
    </p>
    <p class="mt-2">
      {{ t("Wir verarbeiten personenbezogene Daten einer Person („betroffene Person“) auf Basis der folgenden Rechtsgrundlagen:") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.2.1. {{ t("Einwilligung des Betroffenen") }}
    </p>
    <p class="mt-2">
      {{ t("Soweit wir für bestimmte Zweck eine Einwilligung der betroffenen Person einholen, ist Art. 6 Abs. 1 S. 1 lit. a DSGVO Rechtsgrundlage.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.2.2. {{ t("Erfüllung vertraglicher Pflichten") }}
    </p>
    <p class="mt-2">
      {{ t("Soweit die Verarbeitung zur Erfüllung eines Vertrages erforderlich ist, dessen Vertragspartei die betroffene Person ist, ist Art. 6 Abs. 1 S. 1 lit. b DSGVO Rechtsgrundlage. Dies gilt auch für Verarbeitungsvorgänge, die zur Durchführung vorvertraglicher Maßnahmen erforderlich sind.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.2.3. {{ t("Gesetzliche Vorgaben und Verpflichtungen") }}
    </p>
    <p class="mt-2">
      {{ t("Soweit die Verarbeitung zur Erfüllung einer rechtlichen Verpflichtung erforderlich ist, der wir unterliegen, ist Art. 6 Abs. 1 S. 1 lit. c DSGVO Rechtsgrundlage.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.2.4. {{ t("Wahrung berechtigter Interessen") }}
    </p>
    <p class="mt-2">
      {{ t("Soweit die Verarbeitung zur Wahrung unseres berechtigten Interesses oder eines Dritten erforderlich und die Interessen, Grundrechte und Grundfreiheiten der betroffenen Person das erstgenannte Interesse nicht überwiegen, ist Art. 6 Abs. 1 S. 1 lit. f DSGVO Rechtsgrundlage.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.3. {{ t("Speicherdauer und Löschung personenbezogener Daten") }}
    </p>
    <p class="mt-2">
      {{ t("Die personenbezogenen Daten werden gelöscht oder gesperrt, sobald keine Rechtsgrundlage für die Verarbeitung mehr besteht.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.4. {{ t("Empfänger personenbezogener Daten") }}
    </p>
    <p class="mt-2">
      {{ t("Intern verarbeiten nur die Stellen personenbezogene Daten, die diese für die Erfüllung ihrer Verarbeitungszwecke benötigen. Dies gilt auch für die von uns eingesetzten Auftragsverarbeiter, Dienstleister und Erfüllungsgehilfen. Alle Stellen und Personen, die mit personenbezogenen Daten arbeiten, sind auf das Datengeheimnis verpflichtet und auf den sensiblen Umgang mit solchen Daten hingewiesen.") }}
    </p>
    <p class="mt-2">
      {{ t("An Dritte werden personenbezogene Daten nur dann weitergegeben, wenn dies im Einklang mit den Datenschutzvorschriften steht. Insbesondere zur Durchführung unseres Geschäftsbetriebs eingesetzte Personen (z.B. Banken, Steuerberater, Dienstleister für EDV- und IT-Leistungen) sowie staatliche Stellen/Behörden erhalten gegebenenfalls Ihre personenbezogenen Daten, soweit dies zur Erfüllung einer gesetzlichen Verpflichtung erforderlich ist.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.5. {{ t("Datenverarbeitung in Drittländern") }}
    </p>
    <p class="mt-2">
      {{ t("Teilweise erfordern unsere Leistungen die Verarbeitung von personenbezogenen Daten in Ländern außerhalb der EU/des EWR („Drittländer“) durch unsere Auftragsverarbeiter. Soweit eine Verarbeitung personenbezogener Daten stattfindet und kein dem europäischen Standard entsprechendes Datenschutzniveau in dem Land besteht, das durch eines Angemessenheitsbeschlusses gem. Art. 45 Abs. 3 DSGVO durch die EU-Kommission bestätigt wurde, haben wir zur Herstellung geeigneter Garantien im Sinne von Art. 46 DSGVO mit den betroffenen Auftragsverarbeitern EU-Standardvertragsklauseln abgeschlossen. Eine Kopie der EU-Standardvertragsklauseln finden Sie unter https://eur-lex.europa.eu/legal-content/DE/TXT/PDF/?uri=CELEX:32021D0914&from=DE.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6. {{ t("Betroffenenrechte") }}
    </p>
    <p class="mt-2">
      {{ t("Der betroffenen Person stehen folgende Rechte nach der DSGVO gegenüber uns als Verantwortlichen zu:") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.1. {{ t("Auskunftsrecht") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 15 DSGVO besteht das Recht, Auskunft über die von uns verarbeiteten personenbezogenen Daten zu verlangen. Insbesondere kann die betroffene Person folgende Informationen verlangen:") }}
    </p>
    <p class="mt-2">
      • {{ t("Verarbeitungszwecke,") }}
    </p>
    <p class="mt-2">
      • {{ t("Kategorien der Daten,") }}
    </p>
    <p class="mt-2">
      • {{ t("Kategorien von Empfängern, gegenüber denen die personenbezogenen Daten offengelegt wurden oder werden sowie der Information, ob die personenbezogenen Daten in ein Drittland oder an eine internationale Organisation übermittelt werden (in diesem Zusammenhang kann die betroffene Person verlangen, über die geeigneten Garantien gem. Art. 46 DSGVO unterrichtet zu werden),") }}
    </p>
    <p class="mt-2">
      • {{ t("geplante Speicherdauer,") }}
    </p>
    <p class="mt-2">
      • {{ t("Bestehen eines Rechts auf Berichtigung, Löschung, Einschränkung der Verarbeitung oder Widerspruch,") }}
    </p>
    <p class="mt-2">
      • {{ t("Bestehen eines Beschwerderechts, die Herkunft ihrer Daten, sofern diese nicht bei uns erhoben wurden,") }}
    </p>
    <p class="mt-2">
      • {{ t("etwaige Bestehen einer automatisierten Entscheidungsfindung einschließlich Profiling gemäß Art. 22 Abs. 1 und 4 DSGVO und – zumindest in diesen Fällen – aussagekräftige Informationen über die involvierte Logik sowie die Tragweite und die angestrebten Auswirkungen einer derartigen Verarbeitung für die betroffene Person verlangen.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.2. {{ t("Recht auf Berichtigung") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 16 DSGVO besteht das Recht auf Berichtigung und/oder Vervollständigung der personenbezogenen Daten, sofern diese unrichtig oder unvollständig sind.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.3. {{ t("Recht auf Einschränkung der Verarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 18 DSGVO besteht das Recht, die Einschränkung der Verarbeitung der personenbezogenen Daten zu verlangen, soweit die Richtigkeit der personenbezogenen Daten von der betroffenen Person bestritten wird oder die Verarbeitung unrechtmäßig ist.") }}
    </p>
    <p class="mt-2">
      {{ t("Wurde die Einschränkung der Verarbeitung eingeschränkt, wird die betroffene Person von uns unterrichtet, bevor die Einschränkung aufgehoben wird.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.4. {{ t("Recht auf Löschung") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 17 DSGVO besteht das Recht auf Löschung der personenbezogenen Daten, soweit nicht die Verarbeitung zur Ausübung des Rechts auf freie Meinungsäußerung und Information, zur Erfüllung einer rechtlichen Verpflichtung, aus Gründen des öffentlichen Interesses oder zur Geltendmachung, Ausübung oder Verteidigung von Rechtsansprüchen erforderlich ist.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.5. {{ t("Recht auf Unterrichtung") }}
    </p>
    <p class="mt-2">
      {{ t("Hat die betroffene Person das Recht auf Berichtigung, Löschung oder Einschränkung der Verarbeitung gegenüber uns geltend gemacht, sind wir verpflichtet, allen Empfängern, denen die personenbezogenen Daten offengelegt wurden, die Berichtigung, Löschung der personenbezogenen Daten oder Einschränkung der Verarbeitung mitzuteilen, es sei denn, dies erweist sich als unmöglich oder ist mit einem unverhältnismäßigen Aufwand verbunden.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.6. {{ t("Recht auf Datenübertragbarkeit") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 20 DSGVO besteht das Recht die personenbezogenen Daten, die die betroffene Person uns bereitgestellt hat, in einem strukturierten, gängigen und maschinenlesbaren Format zu erhalten oder die Übermittlung an einen anderen Verantwortlichen zu verlangen.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.7. {{ t("Widerspruchsrecht") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 21 DSGVO besteht das Recht, Widerspruch gegen die Verarbeitung einzulegen, sofern die Verarbeitung aufgrund von Art. 6 Abs. 1 S. 1 lit. e oder lit. f DSGVO erfolgt.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.8. {{ t("Recht auf Widerruf der datenschutzrechtlichen Einwilligungserklärung") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 7 Abs. 3 DSGVO besteht das Recht, die datenschutzrechtliche Einwilligungserklärung jederzeit zu widerrufen. Durch den Widerruf der Einwilligung wird die Rechtmäßigkeit der aufgrund der Einwilligung bis zum Widerruf erfolgten Verarbeitung nicht berührt.") }}
    </p>
    <p class="text-base font-bold mt-4">
      1.6.9. {{ t("Recht auf Beschwerde bei einer Aufsichtsbehörde") }}
    </p>
    <p class="mt-2">
      {{ t("Gemäß Art. 77 DSGVO besteht das Recht sich bei einer Datenschutz-Aufsichtsbehörde über unsere Verarbeitung der personenbezogenen Daten zu beschweren.") }}
    </p>
    <p class="text-xl font-bold mt-8">
      2. {{ t("Ergänzende Hinweise für die Webseite") }}
    </p>
    <p class="mt-2">
      {{ t("Wir sind für unsere Webseite introfy.app sowie dessen Unterseiten („Webseite“) verantwortlich. Durch die Nutzung unserer Webseite werden personenbezogene Daten verarbeitet.") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.1. {{ t("Bereitstellung der Webseite und Erstellung von Logfiles") }}
    </p>
    <p class="mt-2">
      {{ t("Beim Aufruf unserer Webseite erfassen wir automatisiert Daten und Information vom Endgerät des Nutzers (sogenannte Logfiles). Dies umfasst insbesondere:") }}
    </p>
    <p class="mt-2">
      • {{ t("IP-Adresse") }}
    </p>
    <p class="mt-2">
      • {{ t("Datum/Uhrzeit") }}
    </p>
    <p class="mt-2">
      • {{ t("Browsertyp") }}
    </p>
    <p class="mt-2">
      • {{ t("Internet-Serviceprovider") }}
    </p>
    <p class="mt-2">
      • {{ t("Betriebssystem des Endgeräts") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.1.1. {{ t("Auftragsverarbeiter") }}
    </p>
    <p class="mt-2">
      {{ t("Zur Bereitstellung unserer Webseite bedienen wir uns der Dienste von Google Cloud EMEA Ltd., mit dem wir einen Auftragsverarbeitungsvertrag geschlossen haben.") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.1.2. {{ t("Verarbeitete Informationen & Dauer der Verarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("In den Logfiles werden insbesondere Informationen über den Browsertyp und die verwendete Version, das Betriebssystem des Endgeräts, der Internet-Service-Provider des Nutzers, die IP-Adresse des Endgeräts sowie Datum und Uhrzeit des Zugriffs auf die Webseite gespeichert.") }}
    </p>
    <p class="mt-2">
      {{ t("Die Logfiles werden binnen 30 Tagen gelöscht.") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.1.3. {{ t("Zweck der Verarbeitung & Rechtsgrundlage") }}
    </p>
    <p class="mt-2">
      {{ t("Die Daten werden zur Darstellung der Webseite auf dem Endgerät des Nutzers, dessen Funktionsfähigkeit sowie zur Analyse etwaiger Störungen benötigt. Zudem dienen uns die Daten zur Optimierung der Webseite und zur Sicherstellung der Sicherheit unserer informationstechnischen Systeme.") }}
    </p>
    <p class="mt-2">
      {{ t("Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Die Erfassung der Logfiles ist für den Betrieb der Internetseite zwingend erforderlich. Es besteht folglich keine Widerspruchsmöglichkeit des Nutzers.") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.2. {{ t("Verwendung unbedingt erforderlicher Cookies") }}
    </p>
    <p class="mt-2">
      {{ t("Wir verwenden auf unserer Webseite unbedingt erforderliche Cookies zur Verfügungstellung unserer Webseite. Cookies sind Textdateien, die im oder vom Internetbrowser auf dem System des Endgerätes des Nutzers bei Besuch eine Webseite gespeichert werden.") }}
    </p>
    <p class="mt-2">
      {{ t("Jedes Cookie enthält eine charakteristische Zeichenkette, die es ermöglicht, den Browser beim nächsten Zugriff auf die Webseite eindeutig zu identifizieren und damit das jeweilige Nutzer-Endgerät. Einzelheiten zu den Cookies finden sich im Consent-Manager unter dem Link „Cookies“ im der Fußzeile dieser Website.") }}
    </p>
    <p class="mt-2">
      {{ t("Die Rechtsgrundlage für die Speicherung der unbedingt erforderlichen Cookies ist § 25 Abs. 2 Nr. 2 TDDDG. Rechtsgrundlage für die Verarbeitung der damit zusammenhängenden personenbezogenen Daten ist Art. 6 Abs. 1 S. 1 lit. f DSGVO. Die Verwendung dieser Cookies ist für den Betrieb der Webseite unbedingt erforderlich. Es besteht folglich seitens des Nutzers keine Widerspruchsmöglichkeit.") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.3. {{ t("Marketing") }}
    </p>
    <p class="mt-2">
      {{ t("Wir nutzen auf unserer Webseite Marketing-Tools, die sogenannte Pixel verwenden („Meta-Pixel“).") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.3.1. {{ t("Gemeinsame Verantwortlichkeit & Drittlandsverarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("Das von uns verwendete Meta-Pixel wird von der Meta Platforms Ireland Ltd., Merrion Road, Dublin 4, D04 X2K5, Irland („Meta“), einer Tochtergesellschaft der Meta, Platforms Inc., 1601, Willow Road Menlo Park, CA 94025, USA, angeboten, die als gemeinsamer Verantwortlicher mit uns agiert. Die wesentlichen Informationen zu der zwischen Meta und uns bestehenden Vereinbarung über die gemeinsame Verantwortlichkeit finden sich hier: https://www.facebook.com/legal/terms/information_about_page_insights_data") }}
    </p>
    <p class="mt-2">
      {{ t("Es kann sein, dass Meta personenbezogene Daten bei der Meta Platforms, Inc., in den USA verarbeitet. In diesem Fall erfolgt die Verarbeitung auf Basis eines Angemessenheitsbeschlusses der EU-Kommission in Verbindung mit der Zertifizierung von Meta Platforms, Inc., beim Data Privacy Framework (Art. 45 DSGVO).") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.3.2. {{ t("Verarbeite Informationen & Dauer der Verarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("Nach Einwilligung zur Nutzung des Meta Pixel werden u.a. folgende Daten an Meta übermittelt:") }}
    </p>
    <p class="mt-2">
      • {{ t("aufgerufene Seiten bzw. URLs") }}
    </p>
    <p class="mt-2">
      • {{ t("die Erreichung von „Website-Zielen“ (z.B. Kontaktanfragen, Newsletter-Anmeldungen)") }}
    </p>
    <p class="mt-2">
      • {{ t("Internet-Verbindungsdaten (IP-Adresse, Datum/Uhrzeit)") }}
    </p>
    <p class="mt-2">
      • {{ t("technische Informationen wie Browser, Endgerät und Bildschirmauflösung") }}
    </p>
    <p class="mt-2">
      • {{ t("zufallsgenerierte User-ID") }}
    </p>
    <p class="mt-2">
      • {{ t("zufallsgenerierte Werbeklick-ID, falls Sie über eine Werbeanzeige auf unsere Website gekommen sind") }}
    </p>
    <p class="text-base font-bold mt-4">
      2.3.3. {{ t("Zweck & Rechtsgrundlage") }}
    </p>
    <p class="mt-2">
      {{ t("Die Verwendung des Meta Pixel ermöglicht es uns, den erzielten Erfolg von Facebook-Werbekampagnen zu messen, Besucher unserer Webseite erneut mit Werbung auf Facebook und Instagram anzusprechen und Werbung aufgrund vorangegangener Seitenbesuche zu personalisieren.") }}
    </p>
    <p class="mt-2">
      {{ t("Die Verarbeitung basiert auf der Einwilligung des Nutzers, die beim erstmaligen Besuch der Webseite erteilt werden kann und welche jederzeit widerrufen werden kann. Die Einwilligung umfasst zum einen das Speichern und Abrufen von Informationen auf dem Nutzer-Endgerät gemäß § 25 Abs. 1 TDDDG und zum anderen die Verarbeitung der dabei entstehenden personenbezogenen Daten zu Marketingzwecken gemäß Art. 6 Abs. 1 S. 1 lit. a DSGVO. Nähere Informationen zum Meta Pixel und die Möglichkeit zum Widerruf der Einwilligung finden sich im Consent-Manager unter dem Link „Cookies“ im der Fußzeile dieser Website.") }}
    </p>
    <p class="text-xl font-bold mt-8">
      3. {{ t("Ergänzende Hinweise zur Plattformnutzung") }}
    </p>
    <p class="mt-2">
      {{ t("Wir bieten eine Plattform zur gegenseitigen Vermittlung von Kandidaten und Arbeitgebern (zusammen „Nutzer“) an. Während die Zurverfügungstellung der Profilangaben und sonstiger Nutzer-Inhalte in der jeweiligen Eigenverantwortlichkeit erfolgt, verarbeiten wir auch personenbezogene Daten in eigener Verantwortlichkeit. Auf die letztgenannten Verarbeitungsprozesse nehmen wir im Folgenden Bezug:") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.1. {{ t("Registrierung, Verifikation und Anmeldung als Kandidat") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.1.1. {{ t("Verarbeitete Informationen & Dauer der Verarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("Im Rahmen der Registrierung, der Verifikation ihrer Person und spätere Anmeldung können folgende personenbezogene Daten von uns verarbeitet werden, soweit Sie diese uns zur Verfügung stellen:") }}
    </p>
    <p class="mt-2">
      • {{ t("Vorname") }}
    </p>
    <p class="mt-2">
      • {{ t("Nachname") }}
    </p>
    <p class="mt-2">
      • {{ t("E-Mail-Adresse") }}
    </p>
    <p class="mt-2">
      • {{ t("Telefonnummer") }}
    </p>
    <p class="mt-2">
      • {{ t("Passwort") }}
    </p>
    <p class="mt-2">
      {{ t("Die personenbezogenen Daten werden gelöscht, wenn der Nutzungsvertrag aufgrund Kündigung endet, Sie Ihren Account bei uns löschen und soweit keine weiteren gesetzlichen Aufbewahrungsfristen an den Daten bestehen.") }}
    </p>
    <p class="mt-2">
      {{ t("Hinweis: Weitere in Ihrem Account durch Sie hinterlegte personenbezogene Daten wie Titel, Geschlecht, Geburtsdatum, Geburtsort, Straße und Hausnummer, Adresszusatz, Postleitzahl, Ort, Bundesland, Land, Staatsangehörigkeiten, Profilbild, Kurzbiografie, bevorzugte Beschäftigungsart, Sprachkenntnisse, Interessen und Hobbies, Fähigkeiten, Zertifikate, sonstige Lebenslaufinformationen, kurze Vorstellungsvideos und ähnliche Nutzer-Inhalte verarbeiten wir lediglich in Ihrem Auftrag. Insoweit entscheiden Sie als der Nutzer auch darüber, inwieweit Arbeitgeber Kenntnis von diesen Inhalten erlangen können, indem Sie diese auf der Plattform veröffentlichen oder auch wieder löschen oder das Profil auf „inaktiv“ schalten.") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.1.2. {{ t("Zweck & Rechtsgrundlage") }}
    </p>
    <p class="mt-2">
      {{ t("Die Verarbeitung der personenbezogenen Daten erfolgt zur Erfüllung unserer vertraglichen Verpflichtungen auf Basis des mit Ihnen geschlossenen Nutzungsvertrages (Art. 6 Abs. 1 S. 1 lit. b DSGVO).") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.2. {{ t("Registrierung, Verifikation und Anmeldung als Arbeitgeber") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.2.1. {{ t("Verarbeitete Informationen & Dauer der Verarbeitung") }}
    </p>
    <p class="mt-2">
      {{ t("Im Rahmen der Registrierung, der Verifikation des Unternehmens und spätere Anmeldung können folgende personenbezogene Daten von uns verarbeitet werden, soweit Sie diese uns zur Verfügung stellen:") }}
    </p>
    <p class="mt-2">
      • {{ t("Kontaktdaten des Ansprechpartners des Unternehmens.") }}
    </p>
    <p class="mt-2">
      {{ t("Die personenbezogenen Daten werden gelöscht, wenn der Nutzungsvertrag aufgrund Kündigung endet, das Unternehmen den Account bei uns löschen und soweit keine weiteren gesetzlichen Aufbewahrungsfristen an den Daten bestehen.") }}
    </p>
    <p class="mt-2">
      {{ t("Weitere im Arbeitgeber-Account durch den Accountinhaber hinterlegte Nutzer-Inhalte verarbeiten wir ausschließlich in dessen Auftrag.") }}
    </p>
    <p class="text-base font-bold mt-4">
      3.2.2. {{ t("Zweck & Rechtsgrundlage") }}
    </p>
    <p class="mt-2">
      {{ t("Die Verarbeitung der personenbezogenen Daten erfolgt zur Erfüllung unserer vertraglichen Verpflichtungen auf Basis des mit Ihnen geschlossenen Nutzungsvertrages (Art. 6 Abs. 1 S. 1 lit. b DSGVO). Soweit für den genannten Zweck personenbezogene Daten eines Mitarbeiters verarbeitet werden, so erfolgt die Verarbeitung auf Basis unseres überwiegenden berechtigten Interesses gem. Art. 6 Abs. 1 S. 1 lit. f DSGVO, da diese Daten erforderlich sind um unsere Dienste dem Arbeitgeber anbieten zu können.") }}
    </p>
    <p class="text-xl font-bold mt-8">
      4. {{ t("Ergänzende Hinweise für die Kommunikation mit uns") }}
    </p>
    <p class="mt-2">
      {{ t("Die nachfolgenden Hinweise gelten für jegliche Kommunikation mit uns.") }}
    </p>
    <p class="mt-2">
      {{ t("Bei der Kontaktaufnahme mit uns werden die personenbezogenen Daten des Anfragenden, die dieser unmittelbar mitteilt oder uns über den jeweiligen Kommunikationsweg mitgeteilt werden ausschließlich zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns verarbeitet. Zielt die Kommunikation auf den Abschluss eines Vertrages ab, so ist die Rechtsgrundlage für die Verarbeitung Art. 6 Abs. 1 S. 1 lit. b DSGVO. In allen anderen Fällen ist Art. 6 Abs. 1 S. 1 lit. f DSGVO die Rechtsgrundlage. Das Interesse des Anfragenden überwiegt nicht unserem Interesse an der Beantwortung der Anfrage; da der Anfragende uns kontaktiert, liegt eine Beantwortung ferner auch in dessen Interesse und dem Anfragenden ist bewusst, dass wir zur Beantwortung Ihrer Anfrage dessen personenbezogenen Daten verarbeiten müssen.") }}
    </p>
    <p class="mt-2">
      {{ t("Die Löschung der personenbezogenen Daten erfolgt, sobald das Anliegen für die Kontaktaufnahme geklärt ist und keine Rechtsgrundlage mehr für die Verarbeitung besteht.") }}
    </p>
    <p class="text-xl font-bold mt-8">
      5. {{ t("Ergänzende Hinweise für Vertragspartner") }}
    </p>
    <p class="mt-2">
      {{ t("Ergänzend gelten die nachfolgenden Hinweise, sofern eine Vertragsbeziehung besteht.") }}
    </p>
    <p class="text-base font-bold mt-4">
      5.1. {{ t("Recht auf Beschwerde bei einer Aufsichtsbehörde") }}
    </p>
    <p class="mt-2">
      {{ t("Welche personenbezogenen Daten im Einzelnen verarbeitet werden, richtet sich nach den Aufgaben innerhalb der Vertragsbeziehung. Wir nutzen die personenbezogenen Daten ausschließlich zu dem Zweck, für den sie uns zur Verfügung gestellt wurden. Dies sind beispielsweise Personalien (Name, Adresse und andere Kontaktdaten, Geburtstag und -ort). Darüber hinaus können dies auch Auftragsdaten (z.B. Zahlungsauftrag), Daten aus der Erfüllung unserer vertraglichen Verpflichtungen (z.B. Umsatzdaten im Zahlungsverkehr), Informationen über Ihre finanzielle Situation (z.B. Bonitätsdaten), Werbe- und Vertriebsdaten sowie andere mit den genannten Kategorien vergleichbare Daten sein.") }}
    </p>
    <p class="mt-2">
      {{ t("Die personenbezogenen Daten werden gelöscht, sobald die Vertragsbeziehung beendet ist und sofern kein anderer Grund für die Verarbeitung besteht.") }}
    </p>
    <p class="text-base font-bold mt-4">
      5.2. {{ t("Recht auf Beschwerde bei einer Aufsichtsbehörde") }}
    </p>
    <p class="mt-2">
      {{ t("Die Verarbeitung erfolgt überwiegend zum Zwecke der Begründung und Durchführung der Vertragsbeziehung; Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. b DSGVO.") }}
    </p>
    <p class="mt-2">
      {{ t("Darüber hinaus verarbeiten wir personenbezogene Daten teilweise auch aufgrund unseres berechtigten Interesses, nämlich zum Zwecke der Kontakt- und Kommunikationsverwaltung, Wirtschaftlichkeitskontrollen, Vertrags- und Projektverwaltung sowie zur Sicherstellung des Betriebs von Informations- und Telekommunikationssystemen. Rechtsgrundlage ist Art. 6 Abs. 1 S. 1 lit. f DSGVO.") }}
    </p>
    <p class="mt-2">
      {{ t("Darüber hinaus sind wir als Unternehmen an diverse rechtliche Verpflichtungen gebunden, die aufgrund geltender Gesetze und Verordnungen einzuhalten sind. Rechtsgrundlage ist bei der Verarbeitung zur Erfüllung gesetzlicher Vorgaben und Verpflichtungen Art. 6 Abs. 1 S. 1 lit. c DSGVO. Hierzu gehören insbesondere steuerrechtliche Aufbewahrungspflichten.") }}
    </p>
  </LandingMainFrame>
</template>
